import type { IConfiguracionServicios, IVariablesServicios } from '../../../modelos/CotizadorServicios/entidades/IConfiguracionServicios';

import { generarIdTemporal } from '../../../globales/componentes/tabla/useEdicionFilas';

export { generarIdTemporal };

const factor = (Nombre: string, Factor: number) => ({ Id: generarIdTemporal(), Nombre, Factor });
const velocidad = (Velocidad: number, Factor: number) => ({ Id: generarIdTemporal(), Velocidad, Factor });

/** Valores del Excel "Cotizador Servicios 05.2026" (hoja Datos Base). Se usan hasta conectar el back. */
export const configuracionServiciosInicial: IConfiguracionServicios = {
    TarifaHoraAscensor: 24500,
    TarifaHoraEscalera: 49000,
    HorasPorModulo: 3,
    MinimoParadas: 2,
    CostoPorParada: 9500,
    FactorEscalera: 1.45,

    PorcentajeCif: 25,
    PorcentajeCostosEspeciales: 0,
    MargenAscensores: 57.53,
    MargenEscaleras: 90,
    PorcentajeIva: 19,

    FactorPlanConekta: 1,
    FactorPlanConektaPlus: 1.25,

    CostosBaseCapacidad: [
        [300, 147000], [630, 147000], [700, 147000], [1000, 147000], [1500, 147000],
        [1501, 176400], [1600, 176400], [1800, 176400], [2000, 176400], [2500, 176400], [3000, 176400],
        [3500, 176400], [4000, 176400], [4500, 176400], [5000, 176400]
    ].map(([CapacidadKg, Costo]) => ({ Id: generarIdTemporal(), CapacidadKg, Costo })),
    CostosBaseRecorrido: [
        [1000, 213150], [2000, 213150], [3000, 213150], [4000, 213150], [5000, 277095],
        [6000, 277095], [7000, 277095], [8000, 277095], [9000, 277095], [10000, 277095],
        [11000, 277095], [12000, 277095], [13000, 277095], [14000, 277095], [15000, 277095]
    ].map(([RecorridoMm, Costo]) => ({ Id: generarIdTemporal(), RecorridoMm, Costo })),
    IncrementosAnuales: [
        { Id: generarIdTemporal(), Anio: 2025, Porcentaje: 2 },
        { Id: generarIdTemporal(), Anio: 2026, Porcentaje: 4 },
        { Id: generarIdTemporal(), Anio: 2027, Porcentaje: 6 }
    ],

    TiposAscensor: ['Pasajeros', 'Carga'],
    Capacidades: ['320', '400', '450', '630', '800', '900', '1000', '1050', '1150', '1200', '1275', '1350', '1600', '1800', '2000', '2275', '2500', '5000'],
    VelocidadesAscensor: [
        velocidad(1, 1), velocidad(1.5, 1), velocidad(1.6, 1), velocidad(1.75, 1), velocidad(2, 1.025),
        velocidad(2.5, 1.025), velocidad(3, 1.03), velocidad(3.5, 1.1), velocidad(4, 1.1)
    ],
    TiposUso: [
        factor('Residencial', 1), factor('Oficina', 1.15), factor('Hotel', 1.15),
        factor('Hospital', 1.3), factor('Centro Comercial', 1.3)
    ],

    TiposEquipoEscalera: [factor('Escalera', 1), factor('Rampa', 0.95), factor('Andén', 0.95)],
    VelocidadesEscalera: [velocidad(0.5, 1), velocidad(0.65, 1), velocidad(0.7, 1)],
    EntornosOperativos: [factor('Indoor', 1), factor('Outdoor', 1)],

    HorariosTrabajo: [
        factor('N/A (No aplica)', 1), factor('HN (Horario nocturno)', 1.3),
        factor('HF (Horario festivo)', 1.2), factor('HS (Horario sábados)', 1.2)
    ],
    CuartoMaquinas: [factor('Sí', 1.1), factor('No', 1)],
    Apf: [factor('DCS', 1), factor('ACCES', 1), factor('E-LINK', 1), factor('N/A', 1)]
};

/** Variables obligatorias diligenciadas: ninguna vacía. */
export const variablesCompletas = (variables: IVariablesServicios) =>
    Object.values(variables).every(valor => valor !== null && valor !== undefined && String(valor) !== '');
